import { OnboardingActionTypes, COMPLETE_ONBOARDING, PAYMENT_IDENTIFIER } from './types';

export const onboardingInitialState = {
    onboardingCompleted: false,
    identifier: '',
};

export function onboardingReducer(state = onboardingInitialState, action: OnboardingActionTypes) {
    switch (action.type) {
        case COMPLETE_ONBOARDING:
            return {
                ...state,
                onboardingCompleted: action.payload,
            };

        case PAYMENT_IDENTIFIER:
            return {
                ...state,
                identifier: action.payload,
            };

        default:
            return state;
    }
}
